import React from 'react';
import { ArrowRight, Play } from 'lucide-react';
export function Hero() {
  return <section className="relative overflow-hidden pt-32 pb-20 lg:pt-48 lg:pb-32" data-id="element-30">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-black" data-id="element-31" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-7xl h-[500px] opacity-20 pointer-events-none" data-id="element-32">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-gradient-to-br from-gray-800 to-transparent rounded-full blur-[120px]" data-id="element-33" />
        <div className="absolute top-20 right-1/4 w-96 h-96 bg-gradient-to-bl from-gray-700 to-transparent rounded-full blur-[120px]" data-id="element-34" />
        <div className="absolute bottom-0 left-1/2 w-96 h-96 bg-gradient-to-t from-gray-800 to-transparent rounded-full blur-[120px]" data-id="element-35" />
      </div>

      <div className="relative mx-auto max-w-7xl px-6 lg:px-8 text-center" data-id="element-36">
        <h1 className="mx-auto max-w-4xl text-5xl font-bold tracking-tight sm:text-7xl mb-8" data-id="element-37">
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-white via-gray-300 to-gray-500" data-id="element-38">
            AVL Group
          </span>
        </h1>

        <p className="mx-auto max-w-2xl text-lg leading-8 text-gray-400 mb-12" data-id="element-39">
          Audio, Video & Language solutions for the next generation AI
          technology
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-40">
          <button className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-lg bg-white px-8 py-3.5 text-sm font-semibold text-black transition-all hover:bg-gray-200 hover:scale-105 active:scale-95" data-id="element-41">
            Explore our products
            <ArrowRight className="h-4 w-4" data-id="element-42" />
          </button>
        </div>
      </div>

      {/* Abstract Grid Floor */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" data-id="element-43" />
    </section>;
}